import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate() {

        if (localStorage.getItem('isLoggedin')) {
            return true;
        }

        const currentURL = window.location.href;
        const indexOfCCL = (currentURL.toLowerCase()).indexOf('cll');
        const isAdminIndexOfCCL = (currentURL.toLowerCase()).indexOf('admin');
        const clientID: any = 0;
        if (indexOfCCL > 0) {
            sessionStorage.clientID = currentURL.substr(indexOfCCL + 3);
        } else if (isAdminIndexOfCCL > 0) {
            sessionStorage.clientID = 0;
        }
        this.router.navigate(['/login']);
        return false;
    }
}


